import customChannelsConfigurationResource from 'src/actions/channels/customChannelsConfigurationResource';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';

const useCustomChannelsConfiguration = () => {
  const { value: config } = useResourceValue(customChannelsConfigurationResource);

  return {
    isFeatureEnabled: config?.enabled,
  };
};

export default useCustomChannelsConfiguration;
